import React, { forwardRef } from 'react';
import Slide, { SlideProps } from '@mui/material/Slide';

const SlideUpTransition = forwardRef(function SlideUpTransition(
  props: SlideProps,
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default SlideUpTransition;